import { Button } from '@casavo/base-ui'
import getConfig from 'next/config'

import Close from '@/design-lib/components/Icons/Close'

import { searchInput, searchInputImage, searchInputWrapper } from './styles.css'

type Props = {
  dataTestId?: string
  onBlur: (value: string) => void
  onChange: (value: string) => void
  placeholder?: string
  value: string
}

export const SearchInput: React.FC<Props> = (props) => {
  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()

  return (
    <div className={searchInputWrapper}>
      <img alt="" className={searchInputImage} src={`${imageBasePath}/images/magnify.svg`} />
      <input
        className={searchInput}
        data-testid={props.dataTestId}
        placeholder={props.placeholder}
        value={props.value}
        onBlur={(e) => props.onBlur(e.target.value)}
        onChange={(e) => props.onChange(e.target.value)}
      />
      {props.value && (
        <Button
          ariaLabel="clear results"
          colorVariant="dark"
          Icon={(props) => <Close {...props} />}
          sizeVariant="small"
          styleVariant="primary"
          onClick={() => props.onChange('')}
        />
      )}
    </div>
  )
}
